import React, { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import ComboTicketItem from '../BoughtTicketItem/ComboTicketItem';
import { compareTicketsByDisplayPriority } from '../../utils';
import styles from './style.module.css';
import { OrderTicketList } from 'types';

const ComboTicketList = memo(({ orderTicket }: { orderTicket: OrderTicketList }) => {
    const comboItems = useMemo(() => {
        if (orderTicket == null || orderTicket.comboItems == null) {
            return [];
        }
        return orderTicket.comboItems;
    }, [orderTicket]);

    return (
        <div className={styles.container}>
            {comboItems?.length > 0 ? (
                comboItems.sort(compareTicketsByDisplayPriority).map((ticket, index) => (
                    <ComboTicketItem
                        key={index}
                        to={'/bought/detail'}
                        comboTicket={{ ...orderTicket, ...ticket, comboItems: [ticket] }} //子券なのでcomboItemsの長さを1にする
                    />
                ))
            ) : (
                <NoSetTicket />
            )}
        </div>
    );
});

// TODO: 不要なら消す。
const NoSetTicket = () => {
    const { t } = useTranslation();
    return <div className={styles.noTicketView}>{t('ticket-detail.no-before-use')}</div>;
};

export default ComboTicketList;
